import ProductGrouping from "./ProductGrouping.page";

export default ProductGrouping;
